import { Link } from 'react-router-dom';

const IndustrialHero = () => {
  return (
    <section className="relative bg-navy py-32 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/d47a03adbb88f4f09360390839abfc8a.jpg"
          alt="Industrial Electrical Services"
          className="w-full h-full object-cover opacity-20"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-navy/90 via-navy/80 to-navy/90"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8">
        <div className="max-w-3xl">
          <nav className="flex items-center gap-2 text-gold text-sm mb-6">
            <Link to="/" className="hover:text-gold-light cursor-pointer">Home</Link>
            <span>/</span>
            <span>Industrial Services</span>
          </nav>

          <h1 className="text-5xl lg:text-6xl font-extrabold text-white mb-6 leading-tight">
            INDUSTRIAL ELECTRICAL SERVICES
          </h1>

          <div className="h-1 w-32 bg-gold mb-8"></div>

          <p className="text-gray-300 text-lg leading-relaxed mb-6">
            NS Electrical WA provides industrial-grade electrical services for warehouses, manufacturing facilities and industrial sites.
          </p>

          <p className="text-gray-300 text-lg leading-relaxed mb-10">
            We prioritise compliance, safety and operational reliability in all industrial environments.
          </p>

          <Link
            to="/contact"
            className="inline-flex items-center gap-2 bg-gold text-navy px-8 py-4 rounded-lg font-bold text-sm tracking-wider hover:bg-gold/90 transition-all whitespace-nowrap cursor-pointer"
          >
            REQUEST A QUOTE
            <i className="ri-arrow-right-line text-xl w-5 h-5 flex items-center justify-center"></i>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default IndustrialHero;